import { render, staticRenderFns } from "./SefosMessage.vue?vue&type=template&id=1b7575c6"
import script from "./SefosMessage.vue?vue&type=script&lang=js"
export * from "./SefosMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports